let initialized = false

export function configure(cfg) {
	initialized = true
}

export function getApiBase() {
	if (!initialized)
		throw new Error('Config not initialized yet!')

	return process.env.REACT_APP_APIBASE || 'http://localhost:5555/api'
}
